export default {
  ecoBlockAnchor: {
    id: 'product_page_ecoblock_anchor',
    defaultMessage: 'More sustainable than new',
  },
  tag1: {
    id: 'product_page_ecoblock_tag_1',
    defaultMessage: 'Tested. Perfected.',
  },
  tag2: {
    id: 'product_page_ecoblock_tag_2',
    defaultMessage: 'Reborn.',
  },
}
